import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaLoanCapacityFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        durationInMonth: [
          entity ? entity.durationInMonth : null,
          Validators.required,
        ],
        rate: [entity ? entity.rate * 100 : null, Validators.required],
        insuranceRate: [
          entity ? entity.insuranceRate * 100 : null,
          Validators.required,
        ],
        rapportLocatif: [
          entity ? entity.rapportLocatif * 100 : null,
          Validators.required,
        ],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      durationInMonth: this.emptyIsNull(this.form.value.durationInMonth),
      rate: this.emptyIsNull(this.form.value.rate / 100),
      insuranceRate: this.emptyIsNull(this.form.value.insuranceRate / 100),
      rapportLocatif: this.emptyIsNull(this.form.value.rapportLocatif / 100),
    };
    return dto;
  }
}
